import { md5Hex } from './md5'

/** 本页代付申请单笔上限（元）；超过只提示、不发请求。 */
export const MAX_PAYOUT_YUAN = 500
export const MAX_PAYOUT_FEN = MAX_PAYOUT_YUAN * 100

export const CREATE_SIGN_KEYS = [
  'alipay_account', 'alipay_name', 'mchId', 'notifyUrl', 'outTradeNo', 'timestamp', 'total'
]
export const QUERY_SIGN_KEYS = ['mchId', 'outTradeNo', 'salaryOrderId', 'timestamp']
export const BALANCE_SIGN_KEYS = ['mchId', 'timestamp']

/**
 * 与支付网关 SzPsyUtils.getSign 一致：
 * 白名单内非空键拼 `参数名=参数值&` → 整行字典序排序 → 末尾 `key=密钥` → MD5 大写。
 * sign / 空值不参与；白名单外字段不参与。
 */
export function salarySign (params, secretKey, whitelist) {
  const src = params || {}
  const keys = whitelist && whitelist.length ? whitelist : Object.keys(src)
  const list = []
  keys.forEach((key) => {
    if (key === 'sign') return
    const value = src[key]
    if (value == null || value === '') return
    list.push(key + '=' + value + '&')
  })
  list.sort()
  const raw = list.join('') + 'key=' + String(secretKey || '')
  return md5Hex(raw).toUpperCase()
}

/**
 * 拼接代付开放接口地址。
 * payUrl 为网关根（如 https://pay.jqpay.vip）；若已带 /api 则不再重复。
 * path 例：salary / salary/query / salary/balance
 */
export function buildSalaryApiUrl (payUrl, path) {
  const base = String(payUrl || '').trim().replace(/\/+$/, '')
  const cleanPath = String(path || '').replace(/^\/+/, '')
  if (!base) {
    throw new Error('请填写支付网关地址')
  }
  if (!cleanPath) {
    throw new Error('接口路径不能为空')
  }
  if (/\/api$/i.test(base)) {
    return base + '/' + cleanPath.replace(/^api\//i, '')
  }
  if (/^api\//i.test(cleanPath)) {
    return base + '/' + cleanPath
  }
  return base + '/api/' + cleanPath
}

export function formatSalaryTimestamp (date) {
  const d = date instanceof Date ? date : new Date()
  const p = (n) => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) +
    ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
}

export function genSalaryOutTradeNo () {
  const d = new Date()
  const p = (n) => String(n).padStart(2, '0')
  const rand = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
  return 'DF' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) +
    p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + rand
}

/** 元 → 分；仅允许最多两位小数的正数。 */
export function yuanToFen (yuanText) {
  const n = String(yuanText == null ? '' : yuanText).trim()
  if (!/^\d+(\.\d{1,2})?$/.test(n) || n === '0' || n === '0.0' || n === '0.00') {
    throw new Error('代付金额须为正数，最多两位小数')
  }
  const parts = n.split('.')
  const yuan = Number(parts[0])
  const fenPart = ((parts[1] || '') + '00').slice(0, 2)
  return yuan * 100 + Number(fenPart)
}

/** 校验单笔上限（含 500 元）；超限抛错，不发请求。 */
export function assertPayoutFenWithinLimit (fen) {
  if (!Number.isFinite(fen) || fen <= 0) {
    throw new Error('代付金额须为正数，最多两位小数')
  }
  if (fen > MAX_PAYOUT_FEN) {
    throw new Error('出款金额不能超过 500 元')
  }
  return fen
}

export function fenToYuanText (fen) {
  const v = Number(fen)
  if (!Number.isFinite(v)) return '--'
  return (v / 100).toFixed(2)
}
